module.exports = __webpack_public_path__ + "img/2dc05e6.jpg";